import { render, staticRenderFns } from "./DHWSMonitor.vue?vue&type=template&id=1122f219&scoped=true"
import script from "./DHWSMonitor.vue?vue&type=script&lang=js"
export * from "./DHWSMonitor.vue?vue&type=script&lang=js"
import style0 from "./DHWSMonitor.vue?vue&type=style&index=0&id=1122f219&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1122f219",
  null
  
)

export default component.exports